var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAssesoraments = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14px",
  height: "14px",
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Assessories") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Inici/Menu-Obert",
  transform: "translate(-31.000000, -254.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu-Lateral",
  transform: "translate(0.000000, 83.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Assesoraments",
  transform: "translate(31.000000, 166.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,17.74 L0,6.05 C0,5.78155 0.105,5.5397 0.315,5.32375 C0.525,5.1078 0.77,5 1.05,5 L12.95,5 C13.21845,5 13.4603,5.1078 13.67625,5.32375 C13.8922,5.5397 14,5.78155 14,6.05 L14,15.15 C14,15.41845 13.8922,15.6603 13.67625,15.87625 C13.4603,16.0922 13.21845,16.2 12.95,16.2 L2.8,16.2 L0.8925,18.1075 C0.72905,18.27095 0.5397,18.30875 0.32375,18.22125 C0.1078,18.13375 0,17.97345 0,17.74 M3.325,8.8675 L10.6925,8.8675 C10.8325,8.8675 10.9522,8.8178 11.05125,8.71875 C11.1503,8.6197 11.2,8.49405 11.2,8.3425 C11.2,8.19095 11.1503,8.0653 11.05125,7.96625 C10.9522,7.8672 10.82655,7.8175 10.675,7.8175 L3.3075,7.8175 C3.1675,7.8175 3.0478,7.8672 2.94875,7.96625 C2.8497,8.0653 2.8,8.19095 2.8,8.3425 C2.8,8.49405 2.8497,8.6197 2.94875,8.71875 C3.0478,8.8178 3.17345,8.8675 3.325,8.8675 M3.325,11.1425 L10.6925,11.1425 C10.8325,11.1425 10.9522,11.0928 11.05125,10.99375 C11.1503,10.8947 11.2,10.76905 11.2,10.6175 C11.2,10.46595 11.1503,10.3403 11.05125,10.24125 C10.9522,10.1422 10.82655,10.0925 10.675,10.0925 L3.3075,10.0925 C3.1675,10.0925 3.0478,10.1422 2.94875,10.24125 C2.8497,10.3403 2.8,10.46595 2.8,10.6175 C2.8,10.76905 2.8497,10.8947 2.94875,10.99375 C3.0478,11.0928 3.17345,11.1425 3.325,11.1425 M3.325,13.4175 L7.77,13.4175 C7.91,13.4175 8.0297,13.3678 8.12875,13.26875 C8.2278,13.1697 8.2775,13.04405 8.2775,12.8925 C8.2775,12.74095 8.2278,12.6153 8.12875,12.51625 C8.0297,12.4172 7.90405,12.3675 7.7525,12.3675 L3.3075,12.3675 C3.1675,12.3675 3.0478,12.4172 2.94875,12.51625 C2.8497,12.6153 2.8,12.74095 2.8,12.8925 C2.8,13.04405 2.8497,13.1697 2.94875,13.26875 C3.0478,13.3678 3.17345,13.4175 3.325,13.4175",
  id: "icon-assesoraments"
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAssesoraments);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_assesoraments.954f071dbf29e6d554e443b6cf6b1e8c.svg";